import { render, staticRenderFns } from "./vcHeader.vue?vue&type=template&id=1990dc72&scoped=true&"
import script from "./vcHeader.vue?vue&type=script&lang=js&"
export * from "./vcHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1990dc72",
  null
  
)

export default component.exports